export const LocaleType = {
    ETC: 'ETC',
    US: 'US',
    KR: 'KR',
    JP: 'JP',
    CN: 'CN',
    TH: 'TH',
    VN: 'VN',
    MN: 'MN',
    ID: 'ID',
    RU: 'RU',
    TW: 'TW'
}

export const LocaleGroupType = {
    ETC: 'ETC',
    University: 'University',
    Company: 'Company'
}
